import React from 'react'
import { Field, withFormik } from 'formik'
import { Icon, List, Progress } from 'antd'
import debounce from 'lodash.debounce'

import CreatorItemAdder from './CreatorItemAdder'
import CreatorListSaveAndFork from './CreatorListSaveAndFork'
import CreatorTodoEditor from './CreatorTodoEditor'
import FormikFieldAntdInputWrapper from './FormikFieldAntdInputWrapper'

class CreatorListEditor extends React.Component {
  constructor (props) {
    super(props)
    this.renderItem = this.renderItem.bind(this)
    this.updateListTitle = debounce(this.props.updateListTitle, 1000)
    this.updateDescriptionTitle = debounce(
      this.props.updateListDescription,
      1000
    )
    this.itemUpdaters = {}
    this.getTodoUpdater = this.getTodoUpdater.bind(this)
  }

  getTodoUpdater (itemKey) {
    let updater = this.itemUpdaters[itemKey]
    if (typeof updater !== 'function') {
      updater = debounce(newTitle => {
        this.props.updateTodoTitle(itemKey, newTitle)
      }, 1000)
      this.itemUpdaters[itemKey] = updater
    }
    return updater
  }

  renderItem (todoItem, i) {
    const highlighted = i === this.props.highlightedTodoIndex
    const { id } = todoItem

    return (
      <List.Item className='edit-todo'>
        <CreatorTodoEditor
          key={id}
          todoItem={todoItem}
          highlighted={highlighted}
          index={i}
          updateTodoCompletion={completed => {
            this.props.updateTodoCompletion(id, completed)
          }}
          deleteTodo={() => {
            this.props.deleteTodo(id)
          }}
          updateTodoTitle={this.getTodoUpdater(id)} />
      </List.Item>
    )
  }

  render () {
    const { todoItems } = this.props.todos

    const isSynced =
      this.props.listInfo.title === this.props.values.listTitle &&
      this.props.listInfo.description === this.props.values.listDescription &&
      todoItems.every(
        todoItem => todoItem.title === this.props.values[`todo-${todoItem.id}`]
      )
    const saveStatus = isSynced ? 'SAVED' : 'SAVING'

    const numComplete = todoItems.filter(todoItem => todoItem.completed).length
    const percentComplete = Math.floor((100 * numComplete) / todoItems.length)
    const complete = percentComplete === 100
    const progressBarClassNames = complete
      ? 'complete-progress todo-progress'
      : 'todo-progress'
    const progressCheckClassNames = complete
      ? 'complete-progress-check todo-progress-check'
      : 'todo-progress-check'

    return (
      <section className='todo-app'>
        <CreatorListSaveAndFork
          status={saveStatus}
          forkList={() => {
            this.props.copyTodoList(this.props.listInfo.listId)
          }} />
        <div className='list-info-editor'>
          <Field
            type='INPUT'
            id='list-title-editor'
            name='listTitle'
            emptyAllowed={false}
            fallback='Title'
            maxLength={50}
            updateField={this.updateListTitle}
            component={FormikFieldAntdInputWrapper} />
          <Field
            type='TEXTAREA'
            id='list-description-editor'
            name='listDescription'
            emptyAllowed={true}
            fallback='Description (optional)'
            updateField={this.updateDescriptionTitle}
            component={FormikFieldAntdInputWrapper} />
        </div>
        <div className='todo-status-wrapper'>
          <Progress
            className={progressBarClassNames}
            percent={percentComplete}
            showInfo={false}
            strokeLinecap='square' />
          <Icon
            className={progressCheckClassNames}
            type='check-circle'
            theme='twoTone'
            twoToneColor='#70C060' />
          <List
            className='todo-list'
            size='large'
            dataSource={todoItems}
            renderItem={this.renderItem} />
          <CreatorItemAdder
            createTodo={() => {
              this.props.createTodo(`Item ${todoItems.length + 1}`)
            }} />
        </div>
      </section>
    )
  }
}

export default withFormik({
  enableReinitialize: true,
  handleSubmit: () => {},
  isInitialValid: true,
  mapPropsToValues: props => {
    const values = {}
    values.listTitle = props.listInfo.title
    values.listDescription = props.listInfo.description
    props.todos.todoItems.forEach(todoItem => {
      values[`todo-${todoItem.id}`] = todoItem.title
    })
    return values
  },
  validateOnBlur: true,
  validateOnChange: true
})(CreatorListEditor)



// WEBPACK FOOTER //
// ./src/components/CreatorListEditor.js